import React from 'react';
import { motion } from 'framer-motion';
export function ChangelogPage() {
  const logs = [{
    version: 'v2.1.0',
    date: 'October 12, 2023',
    changes: ['Enhanced multi-currency support for international transactions.', 'Refined dashboard analytics UI.']
  }, {
    version: 'v2.0.4',
    date: 'September 28, 2023',
    changes: ['Performance optimization for high-volume stores.', 'Minor security patch for API authentication.']
  }, {
    version: 'v2.0.0',
    date: 'August 15, 2023',
    changes: ['Major Release: Sovereign Architecture.', 'Complete UI overhaul.', 'Real-time sync engine upgrade.']
  }];
  return <div className="min-h-screen bg-sovereign-navy text-white pt-32 pb-20" data-id="element-167">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-168">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-4xl font-serif text-white mb-16 text-center" data-id="element-169">
          Evolution
        </motion.h1>

        <div className="relative border-l border-sovereign-gold/30 ml-4 md:ml-0 pl-8 md:pl-12 space-y-16" data-id="element-170">
          {logs.map((log, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="relative" data-id="element-171">
              <div className="absolute -left-[37px] md:-left-[53px] top-2 w-4 h-4 rounded-full bg-sovereign-navy border-2 border-sovereign-gold" data-id="element-172" />

              <div className="flex flex-col md:flex-row md:items-baseline gap-2 md:gap-8 mb-4" data-id="element-173">
                <span className="text-2xl font-serif text-white" data-id="element-174">
                  {log.version}
                </span>
                <span className="text-sm text-gray-400 font-light uppercase tracking-widest" data-id="element-175">
                  {log.date}
                </span>
              </div>

              <ul className="space-y-2" data-id="element-176">
                {log.changes.map((change, idx) => <li key={idx} className="text-gray-400 font-light leading-relaxed" data-id="element-177">
                    {change}
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </div>;
}